export const TourSteps = {
  '/workbench-ui/employee/workbench/manage-master-data':[
    {
      content:
        'Welcome to Manage Master Data screen. Here you can search and update any master data that is configured for the logged in user tenant',
      target: '.manage-master-wrapper',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'Select any module name where the master is present',
      target: '.wbh-mdms-module-name',
      disableBeacon: true,
      placement: 'center',
      title:"Manage Master Data"
    },
    
    {
      content:
        'Select any master name where the master is present',
      target: '.wbh-mdms-master-name',
      disableBeacon: true,
      placement: 'center',
      title:"Manage Master Data"
    },
  ],
  '/workbench-ui/employee/workbench/mdms-search-v2':[
    {
      content:
        'Welcome to the master data search screen. Here you can search the master data added under this master',
      target: '.search-wrapper',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'Select any field value and enter the text by which data can be filtered',
      target: '.label-field-pair',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'Filter the master data by clicking on this search by selecting any field and exact value',
      target: '.search-button-wrapper',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'To add new master data under this master click on the Add Master Data button',
      target: '.mdms-add-btn',
      disableBeacon: true,
      placement: 'auto',
      title:"Manage Master Data"
    },
    
  ],
  '/workbench-ui/employee/workbench/mdms-add-v2':[
    {
      content:
        'Welcome to the master data search screen. Here you can search the master data added under this master',
      target: '.field-string',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'select the Reference master data',
      target: '.form-select ',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'Fill all the details by clicking on the Add Master Data',
      target: '.submit-bar',
      disableBeacon: true,
      placement: 'auto',
      title:"Manage Master Data"
    },
    
  ],
  '/workbench-ui/employee/workbench/mdms-view':[
    {
      content:
        'Welcome to the master data search screen. Here you can search the master data added under this master',
      target: '.action-bar-wrap',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'select the Reference master data',
      target: '.menu-wrap',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    }  
  ],
  '/workbench-ui/employee/workbench/localisation-search':[
    {
      content:
        'Welcome to the master data search screen. Here you can search the master data added under this master',
      target: '.search-wrapper',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'Select any field value and enter the text by which data can be filtered',
      target: '.label-field-pair',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'Filter the master data by clicking on this search by selecting any field and exact value',
      target: '.search-button-wrapper',
      disableBeacon: true,
      placement: 'bottom',
      title:"Manage Master Data"
    },
    {
      content:
        'To add new master data under this master click on the Add Master Data button',
      target: '.mdms-add-btn',
      disableBeacon: true,
      placement: 'auto',
      title:"Manage Master Data"
    },
    
  ],
}
